<template>
  <div id="Biddetail">
    <!-- <h3>用章详情查看页面</h3> -->
    <loading-overlay v-if="isLoading"></loading-overlay>
    <el-row>
      <el-col :span="14">
        <div class="contain">
          <el-form
            :model="form"
            label-width="200px"
            :rules="rules"
            ref="ruleForm"
          >
            <!-- <el-form-item label="申请人" prop="applicant">
              <el-select v-model="form.applicant" placeholder="请选择" class="input">
                <el-option v-for="item in approve" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="招标人" prop="tenderee">
              <el-input
                class="input"
                v-model="form.tenderee"
                placeholder="请输入"
                :disabled="IsShow"
              ></el-input>
            </el-form-item>
            <el-form-item label="采购文件名称" prop="procurefile">
              <el-input
                class="input"
                v-model="form.procurefile"
                placeholder="请输入"
                :disabled="IsShow"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布途径" prop="publishway">
              <el-input
                class="input"
                v-model="form.publishway"
                placeholder="请输入"
                :disabled="IsShow"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布日期" prop="publishDate">
              <div
                class="date_box"
                @mouseover="onMouseOver()"
                @mouseleave="onMouseleave()"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="form.publishDate"
                  type="date"
                  placeholder="请选择日期"
                  :disabled="IsShow"
                >
                </el-date-picker>
                <i class="el-icon-date" ref="iconDate"></i>
              </div>
            </el-form-item>

            <el-form-item label="方式" prop="way">
              <el-input
                class="input"
                v-model="form.way"
                placeholder="请输入"
                :disabled="IsShow"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="tenderType">
              <el-input
                class="input"
                v-model="form.tenderType"
                placeholder="请输入"
                :disabled="IsShow"
              ></el-input>
            </el-form-item>
            <el-form-item label="采购内容" prop="procurecontent">
              <el-input
                class="input"
                v-model="form.procurecontent"
                placeholder="请输入"
                :disabled="IsShow"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
              <el-select
                v-model="form.applicant"
                clearable
                placeholder="请选择"
                class="input"
                @change="selectChange()"
                :disabled="IsShow"
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="拟组建的法律服务团队成员" prop="lawTerm">
              <el-select
                v-model="form.lawTerm"
                clearable
                placeholder="请选择"
                :disabled="IsShow"
                class="input"
                multiple
                filterable
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请事项" prop="matter">
              <el-input
                class="input"
                v-model="form.matter"
                :autosize="{ minRows: 3 }"
                type="textarea"
                placeholder="请输入"
                :disabled="IsShow"
              />
            </el-form-item>
            <el-form-item label="申请理由" prop="reason">
              <el-input
                class="input"
                v-model="form.reason"
                :autosize="{ minRows: 3 }"
                type="textarea"
                placeholder="请输入"
                :disabled="IsShow"
              />
            </el-form-item>
            <el-form-item label="投标决策委员会审核意见" prop="opinion">
              <!-- <el-input v-model="form.cuase" class="input" placeholder="请输入"></el-input> -->
              <el-input
                class="input"
                v-model="form.opinion"
                :autosize="{ minRows: 3 }"
                type="textarea"
                placeholder="请输入"
                :disabled="IsShow"
              />
            </el-form-item>
            <el-form-item label="投标决策委员会成员" prop="bidDecisionTeam">
              <el-select
                v-model="form.bidDecisionTeam"
                placeholder="请选择"
                class="input"
                clearable
                multiple
                :disabled="IsShow"
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用章类型" prop="seal.sealType">
              <el-select
                v-model="form.seal.sealType"
                placeholder="请选择"
                class="input"
                :disabled="IsShow"
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 审核不通过出现 -->
            <el-form-item
              label="部门审批人"
              prop="departmentLeaders"
              v-if="form.status == 2"
            >
              <el-select
                class="input"
                v-model="form.departmentLeaders"
                placeholder="请先选择申请人"
                filterable
                :disabled="IsShow"
              >
                <el-option
                  v-for="item in depLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="二次审批人"
              prop="applicantS"
              v-if="form.status == 2"
            >
              <el-select
                v-model="form.applicantS"
                placeholder="请选择"
                class="input"
                filterable
                :disabled="IsShow"
              >
                <el-option
                  v-for="item in tenderapprove"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="附件" prop="file">
              <el-upload
                v-if="form.status == 2"
                :disabled="IsShow"
                class="upload_file"
                v-model="form.file"
                drag
                action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=投标审批"
                multiple
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                :file-list="FileList"
                :on-success="uploadSuccess"
                :on-change="onChange"
                :show-file-list="false"
                :on-progress="onProgress"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  最大可上传50M,jpg,jpeg,png,doc,docx,xls,xlsx类型可上传
                </div>
              </el-upload>
              <!-- 附件回显 -->
              <div
                v-for="(item, index) in FileList"
                :key="item.uid"
                class="file_show"
                style="margin-top: 10px"
              >
                <div class="fj" v-if="!item.isShow">
                  <div style="flex: 1">
                    <img
                      src="../../assets/file/word.svg"
                      v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                    />
                    <img
                      src="../../assets/file/xls.svg"
                      v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                    />
                    <img
                      src="../../assets/file/png.svg"
                      v-if="
                        item.ftype == 'jpg' ||
                        item.ftype == 'jpeg' ||
                        item.ftype == 'png'
                      "
                    />
                    <img
                      src="../../assets/file/PDF.svg"
                      v-if="item.ftype == 'pdf'"
                    />
                  </div>
                  <div class="name" style="flex: 9">
                    <div class="fname" style="word-break: break-all">
                      {{ item.name }}
                    </div>
                    <div class="word">
                      <span
                        @click="look(item)"
                        class="look"
                        v-if="$store.state.rolesname.includes('Biddetail_look')"
                        >预览</span
                      >
                      <span
                        class="down"
                        @click="down(item)"
                        v-if="$store.state.rolesname.includes('Biddetail_down')"
                        >下载</span
                      >
                      <span
                        @click="del(index)"
                        class="del"
                        v-if="form.status == 2 && form.isEdit"
                        >删除</span
                      >
                    </div>
                  </div>
                </div>
                <!--文件上传进度条-->
                <div class="uploadprocess" v-else>
                  <div>
                    <div class="jdtext">
                      <div class="uploadname">{{ item.name }}</div>
                      <div class="per">{{ item.curPercentage }}%</div>
                    </div>
                    <el-progress
                      :percentage="item.curPercentage"
                      :show-text="false"
                    ></el-progress>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="right">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in logs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.content }}</div>
                <div class="time">
                  {{ handleFTime(item.timestamp) }}
                </div>
              </div>
              <div style="color: #909399">{{ item.type }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="right" v-if="processlogs.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in processlogs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.type }}</div>

                <div class="time">
                  {{ item.timestamp }}
                </div>
              </div>
              <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>

        <div class="right" v-if="Process.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in Process"
              :key="index"
              :timestamp="item.type"
            >
              {{ item.name }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
    <div class="footer">
      <el-button
        type="warning"
        @click="applySeal('ruleForm')"
        v-if="
          (form.seal.sealStatus == -1 || form.seal.sealResult == 1) &&
          form.status == 0 &&
          form.isEdit
        "
        >申请用章</el-button
      >
      <el-button
        type="primary"
        @click="Post('ruleForm')"
        v-if="form.status == 2 && form.isEdit"
        >重新提交</el-button
      >
      <el-button class="history" @click="history">返回</el-button>
    </div>
    <el-dialog
      title="用章申请"
      center
      :visible.sync="applyDialog"
      width="40%"
      @close="closedialog"
    >
      <el-form
        class="form"
        label-width="120px"
        :model="dialogform"
        :rules="ruleseal"
        ref="ruleformseal"
      >
        <el-form-item label="申请人" prop="applicant">
          <el-select
            v-model="dialogform.applicant"
            placeholder="请选择"
            style="width: 50%"
            filterable
            @change="sealChange()"
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select
            v-model="dialogform.sealtype"
            placeholder="请选择"
            style="width: 50%"
            @change="selectChange()"
          >
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门审批人" prop="SealLeaders">
          <el-select
            v-model="dialogform.SealLeaders"
            placeholder="请先选择申请人"
            style="width: 50%"
            clearable
            filterable
          >
            <el-option
              v-for="item in SealdepLeaders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次审批人" prop="approver">
          <el-select
            v-model="dialogform.approver"
            placeholder="请选择"
            style="width: 50%"
            clearable
          >
            <el-option
              v-for="item in Sealapprove"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章事由" prop="reason">
          <el-input
            placeholder="请输入"
            v-model="dialogform.reason"
            type="text"
            style="width: 50%"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="sealfile">
          <el-select
            v-model="dialogform.sealfile"
            placeholder="请选择"
            style="width: 50%"
            multiple
            filterable
            onchange
          >
            <el-option
              v-for="(item, index) in FileList"
              :key="index"
              :label="item.name"
              :value="item.uid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button
            v-if="form.status == 2"
            @click="addEnter('ruleformseal')"
            type="primary"
            >确认</el-button
          >
          <el-button v-else @click="addSealEnter('ruleformseal')" type="primary"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { user } from '../../api/seal'
import { Detail, Edit, SealApply } from '../../api/tender'
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import {
  GetDepartmentLeaders,
  CaseLog,
  CaseProcess,
  CaseApprover
} from '../../api/bankrupt'
import { requestDownLoadFile as downfile } from '../../api/seal'
import mammoth from 'mammoth'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'Biddetail',
  data() {
    return {
      isLoading: false,
      active: 'Biddetail',
      next: true, //是否是三级菜单
      form: {
        seal: {
          sealId: null,
          sealType: '',
          sealStatus: null,
          sealResult: null
        },

        file: []
      },
      logs: [],
      SealdepLeaders: [], //用章申请部门领导人
      depLeaders: [], //部门领导人
      IsShow: true,
      TenderId: '',
      apptype: 'Tender',
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' }
        // { label:"律师函专用章",value:"legal_letter_seal"},
      ], //合同用章
      approve: [], //二次审批人
      Lawyer: [], //律师
      method: [], //方式
      type: [], //类型
      Term: [], //法律团队成员
      tenderapprove: [], //二次审批人
      FileList: [], //文件
      applyDialog: false,
      Sealapprove: [], //用章的二次审批人
      dialogform: {
        //用章
        applicant: '',
        approver: '',
        sealfile: [],
        reason: '投标申请',
        sealtype: '',
        SealLeaders: ''
      },
      ruleseal: {
        applicant: { required: true, message: '不能为空 ', trigger: 'change' },
        approver: { required: true, message: '不能为空 ', trigger: 'change' },
        sealtype: { required: true, message: '不能为空 ', trigger: 'change' },
        reason: { required: true, message: '不能为空 ', trigger: 'change' },
        sealfile: { required: true, message: '不能为空 ', trigger: 'change' },
        SealLeaders: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      rules: {
        tenderee: { required: true, message: '不能为空', trigger: 'change' },
        lawTerm: { required: true, message: '不能为空', trigger: 'change' },
        applicant: { required: true, message: '不能为空', trigger: 'change' },
        seal: {
          sealType: {
            required: true,
            message: '请选择用章类型',
            trigger: 'change'
          }
        },
        applicantS: {
          required: true,
          message: '请选择二次审批人',
          trigger: 'change'
        },
        bidDecisionTeam: {
          required: true,
          message: '不能为空',
          trigger: 'change'
        },
        file: { required: true, message: '不能为空 ', trigger: 'change' },
        departmentLeaders: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        }
      },
      // 文件预览
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数

      Process: {},
      processlogs: {}
    }
  },

  methods: {
    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.uid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.uid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.uid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },
    closedialog() {
      this.apptype = 'Tender'
    },
    del(index) {
      this.FileList.splice(index, 1)
      this.dialogform.sealfile = []
    },
    async down(item) {
      //下载
      this.isLoading = true
      const res = await downfile({
        Id: item.uid
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        this.isLoading = false
        return
      }
      // console.log(res)
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
        this.GetLog()
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      fileReader.readAsText(data)
    },

    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null

      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },
    applySeal(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.dialogform.sealtype = this.form.seal.sealType
          this.applyDialog = true
          this.apptype = this.dialogform.sealtype
          // this.dialogform.applicant = this.form.applicant
          this.sealChange()
        } else {
          this.$message.error('有必填项为空')
        }
      })
    },
    GetDepartmentLeaders(id) {
      //获取部门审批人
      GetDepartmentLeaders({ Id: id }).then((res) => {
        if (res.data.status == 0) {
          if (this.apptype == this.form.seal.sealType) {
            //用章的部门审批人
            // console.log(this.apptype)
            this.SealdepLeaders = res.data.data
            var index = this.SealdepLeaders.findIndex((item) => {
              return item.value == this.dialogform.SealLeaders
            })
            if (index == -1 && this.dialogform.SealLeaders) {
              //不存在，清空
              this.dialogform.SealLeaders = ''
            }
          }
          if (this.apptype == 'Tender') {
            //案件的部门审批人
            this.depLeaders = res.data.data
            var index = this.depLeaders.findIndex((item) => {
              return item.value == this.form.departmentLeaders
            })
            // console.log("index:"+index)
            if (index == -1 && this.form.departmentLeaders) {
              //不存在，清空
              this.form.departmentLeaders = ''
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          if (this.apptype == this.form.seal.sealType) {
            //用章的部门审批人
            this.SealdepLeaders = []
            this.dialogform.SealLeaders = ''
          }
          if (this.apptype == 'Tender') {
            this.depLeaders = []
            this.form.departmentLeaders = ''
          }
          this.$message.error(res.data.message)
        }
      })
    },
    addSealEnter(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          SealApply({
            ApplicantId: this.dialogform.applicant,
            SealType: this.dialogform.sealtype,
            Approver: this.dialogform.approver,
            Filelist: this.dialogform.sealfile,
            TenderId: this.TenderId,
            Reason: this.dialogform.reason,
            SealLeaders: this.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success(res.data.message)
              this.applyDialog = false
              this.form.seal = res.data.data
              this.GetProcess()
              // this.form.seal.sealStatus = 1
              // this.form.seal.sealResult =-1
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
              this.applyDialog = false
            }
            this.isLoading = false
          })
        }
      })
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    selectChange() {
      // this.apptype='tender'
      this.GetApprove()
      this.GetDepartmentLeaders(this.form.applicant)
    },
    sealChange() {
      this.GetApprove()
      this.GetDepartmentLeaders(this.dialogform.applicant)
    },
    //发布日期
    onMouseOver() {
      if (this.form.publishDate != undefined && this.form.publishDate != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },
    Getdetail() {
      this.isLoading = true
      Detail({ Id: this.TenderId }).then((res) => {
        if (res.data.status == 'success') {
          this.form = res.data.data
          this.FileList = this.form.file

          if (this.form.seal == null) {
            this.form.seal = {
              sealId: null,
              sealType: '',
              sealStatus: null,
              sealResult: null
            }
          }
          this.GetProcess()
          if (this.form.status == 2) {
            //审核不通过
            this.IsShow = false
            this.selectChange()
          }
          if (!this.form.isEdit) {
            this.IsShow = true
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },
    Post(form) {
      //提交
      this.form.file = this.FileList.map((v) => {
        return v.uid
      })
      this.$refs[form].validate((success) => {
        if (success) {
          this.dialogform.sealtype = this.form.seal.sealType
          this.applyDialog = true
          this.apptype = this.dialogform.sealtype

          // this.dialogform.applicant = this.form.applicant
          this.sealChange()
        } else {
          this.$message.error('有必填项为空')
        }
      })
    },
    addEnter(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          if (this.form.publishDate) {
            this.form.publishDate = this.JsonTime(this.form.publishDate) //时间格式转换
          }
          Edit({
            Id: this.TenderId,
            FileList: this.form.file,
            Tenderee: this.form.tenderee,
            ProcureFile: this.form.procurefile,
            ApplicantId: this.form.applicant,
            PublishWay: this.form.publishway,
            PublishDate: this.form.publishDate,
            Way: this.form.way,
            TenderType: this.form.tenderType,
            ProcureContent: this.form.procurecontent,
            LegalTeam: this.form.lawTerm,
            Matter: this.form.matter,
            Reason: this.form.reason,
            Opinion: this.form.opinion,
            BidDecisionTeam: this.form.bidDecisionTeam,
            SealType: this.dialogform.sealtype,
            SealReason: this.dialogform.reason,
            SealApplicantId: this.dialogform.applicant,
            Seallist: this.dialogform.sealfile,
            Approver: this.form.applicantS,
            SealApprover: this.dialogform.approver,
            DepartmentLeaders: this.form.departmentLeaders,
            SealLeaders: this.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('投标申请成功，请等待审核!')
              this.$router.push({
                path: `/home/seal/Bidrecord`
              })
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        }
      })
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },
    handleRemove(file, fileList) {
      //删除附件
      this.FileList.forEach((value, index, array) => {
        //删除上传失败的文件
        // console.log(file.uid)
        if (value.uid == file.uid) {
          array.splice(index, 1)
        }
      })
    },
    handlePreview(file) {
      // console.log(file);
    },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    onProgress(event, file) {
      // console.log(file)
      let num = ((event.loaded / event.total) * 100) | 0 //百分比

      this.FileList.forEach((value) => {
        if (value.uid == file.uid) {
          value.curPercentage = num
        }
      })
    },

    onChange(file) {
      if (file.status == 'fail') {
        this.FileList.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
        return this.$message.error(file.name + '上传失败')
      }
    },
    // beforeRemove(file, fileList) {//删除触发
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    beforeUpload(file, filelist) {
      var type = file.name.substring(file.name.lastIndexOf('.') + 1)
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
      this.FileList.push({
        uid: file.uid,
        name: filename,
        ftype: type,
        isShow: true,
        curPercentage: 0
      }) //添加上传的文件

      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.wps,.WPS'.indexOf(type) >=
        0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList) {
      //上传成功
      // console.log(file)
      if (res.status == '0') {
        // this.$refs.fileupload.clearValidate()
        this.FileList.forEach((value) => {
          if (value.uid == file.uid) {
            value.isShow = false
            value.uid = file.response.data.substring(
              file.response.data.lastIndexOf('=') + 1
            )
          }
        })
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
    },
    GetUser() {
      //获取所有律师
      user({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
          if (this.Lawyer.length > 0) {
            // this.form.applicant = this.Lawyer[0].uid
            this.dialogform.applicant = this.Lawyer[0].uid
            // this.selectChange()
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    Getdata() {
      //根据uid获取用户的姓名
      this.form.postTime = this.handleTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
    },
    GetLog() {
      //获取日志
      CaseLog({ Id: this.TenderId, type: 'tender' }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
          if (this.logs.Reason) {
            this.logs.Reason = JSON.parse(this.logs.Reason).Reason
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    // 时间格式
    handleFTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    // 时间格式
    handleTime(time, format) {
      if (time == null || time == undefined || time == '') {
        return ''
      }
      var t = new Date(time.toString().replace(/-/g, '/'))
      var tf = function (i) {
        return (i < 10 ? '0' : '') + i
      }
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear())
            break
          case 'MM':
            return tf(t.getMonth() + 1)
            break
          case 'mm':
            return tf(t.getMinutes())
            break
          case 'dd':
            return tf(t.getDate())
            break
          case 'HH':
            return tf(t.getHours())
            break
          case 'ss':
            return tf(t.getSeconds())
            break
        }
      })
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    GetApprove() {
      //获取二次审批人
      user({ Id: this.form.applicant, apporver: this.apptype }).then((res) => {
        if (res.data.status == 'success') {
          if (this.apptype == this.dialogform.sealtype) {
            this.Sealapprove = res.data.data
            var index = this.Sealapprove.findIndex((item) => {
              return item.id == this.dialogform.approver
            })
            if (index == -1) {
              //不存在，清空二次审批人
              this.dialogform.approver = ''
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.tenderapprove = res.data.data
            var index = this.tenderapprove.findIndex((item) => {
              return item.id == this.form.applicantS
            })

            if (index == -1 && this.form.applicantS != null) {
              //不存在，清空二次审批人
              this.form.applicantS = ''
            }
          }
        }
      })
    },
    Successlog() {
      CaseApprover({ TenderId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetProcess() {
      if (this.form.status == 0 && this.form.seal.sealStatus == 1) {
        CaseProcess({ SealId: this.form.seal.sealId }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      } else {
        CaseProcess({ TenderId: this.TenderId }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      }
    }
  },
  created() {
    this.getvalue()
    this.TenderId = this.$route.query.guid
    this.Getdetail()
    this.GetUser()
    this.GetLog()
    this.Successlog()
  },
  computed: {}
}
</script>
  
<style lang="less" scoped>
// 日历
::v-deep .el-input__prefix {
  display: none;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

#Biddetail .date_box {
  width: 50%;

  .el-icon-date {
    position: absolute;
    top: 50%;
    right: calc(50% + 10px);
    z-index: 9;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }
}

#Biddetail .contain {
  width: 90%;
  margin: auto;
}

#Biddetail .input {
  width: 60%;
}

#Biddetail img {
  width: 100%;
  height: 100%;
}

#Biddetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#Biddetail .word {
  line-height: 18px;
  cursor: default;
}

#Biddetail .footer {
  width: 100%;
  margin: auto;
  text-align: center;
}

#Biddetail .history {
  border: 1px solid #2bc887;
  color: #2bc887;
}
// 附件回显
#Biddetail .upload_file {
  width: 360px;
}

#Biddetail .file_show {
  width: 360px;
}

#Biddetail .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#Biddetail img {
  width: 100%;
  height: 100%;
}

#Biddetail .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}
#Biddetail .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#Biddetail .word {
  line-height: 24px;
  cursor: default;
}
#Biddetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}
#Biddetail .right {
  width: 80%;
  margin: auto;
  margin-top: 3.125rem;
}
#Biddetail .look {
  color: #fe964a;
  margin-right: 10px;
}

#Biddetail .down {
  color: #2bc887;
  margin-right: 10px;
}

#Biddetail .del {
  color: hsl(356, 93%, 50%);
}

//进度条
#Biddetail .uploadprocess {
  width: 360px;
}

#Biddetail .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#Biddetail .jdtext {
  width: 360px;
  display: flex;
}

#Biddetail .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}
</style>